import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import StyledFieldContainer from '../ModalWindows/JobAlertModal/helpers/StyledFieldContainer';
import { useWindowSize } from '../../../utils/hooks';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';

export default function CustomAutocomplete(props) {
  const { options, value, onChange, backgroundColor = 'white', bubblesOutlined = true, placeholder = '' } = props;

  const size = useWindowSize();

  const [inputValue, setInputValue] = useState('');

  return (
    <div
      style={{
        backgroundColor,
        width: '100%',
        borderRadius: '5px'
      }}
    >
      <StyledFieldContainer>
        <Autocomplete
          multiple
          disablePortal={size.width > MOBILE_BREAKPOINT}
          value={value}
          options={options}
          onChange={(e, newValue) => onChange(newValue)}
          inputValue={inputValue}
          popupIcon={<ExpandMoreIcon />}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          getOptionLabel={(option) => option.label}
          renderOption={(params, option) => {
            return option.label === options[0].label || value.find((item) => item.label === option.label) ? (
              false
            ) : (
              <li
                {...params}
                style={{ cursor: 'pointer' }}
                className="d-flex justify-content-between align-items-center ms-3 me-1 py-2"
              >
                {option.label}
              </li>
            );
          }}
          ChipProps={{
            variant: bubblesOutlined ? 'outlined' : 'filled',
            color: 'primary',
            deleteIcon: <CloseIcon />,
            sx: {
              '& .MuiChip-deleteIcon': { color: bubblesOutlined ? '#0194D3' : 'white', fontSize: '16px' }
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={!value.length ? placeholder : ''}
              sx={{
                '& .MuiInput-root': { '&:before': { borderBottom: 'none' } },
                '& .MuiInput-underline:hover:before': {
                  border: 'none !important'
                }
              }}
            />
          )}
          sx={{
            width: '100%',
            height: '100%',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            }
          }}
        />
      </StyledFieldContainer>
    </div>
  );
}
